// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailCellContent_wrapper__-IbnI","link":"EmailCellContent_link__o+lx0"};